import { createSlice } from '@reduxjs/toolkit';
import { formatISO, subDays } from 'date-fns';

export const counsellingNoteSlice = createSlice({
  name: 'counsellingNote',
  initialState: {
    cNotePeriodFilter: {
      name: '90D',
      startDate: formatISO(subDays(new Date(), 90)),
      endDate: formatISO(new Date()),
    },
    notesGrid: {
      chartSerch: '',
      patSerch: '',
      dosSerch: '',
      tovSerch: '',
      noteStSerch: '',
      provId: '',
      provSignSt: '',
      coSigner: '',
      coSignerSt: '',
      actionSt: '',
      payor: '',
      serviceCode: '',
      billSt: '',
      allOpen: 1,
      allSigned: 0,
    },
    phoneNote: false,
    unlockFlag: '',
    renderFormData: {
      data: null,
      type: '',
    },
  },
  reducers: {
    setCnotePeriod: (state, action) => {
      state.cNotePeriodFilter = action.payload;
    },
    setNoteSerchAllsignopen: (state, action) => {
      state.notesGrid.allOpen = action.payload;
      state.notesGrid.allSigned = action.payload;
    },
    setNoteProSerch: (state, action) => {
      state.notesGrid.provId = action.payload;
    },
    updateNoteSerch: (state, action) => {
      const { key, value } = action.payload;
      if (Object.prototype.hasOwnProperty.call(state.notesGrid, key)) {
        state.notesGrid[key] = value;
      }
    },
    setPhoneNotePopup: (state, action) => {
      state.phoneNote = action.payload;
    },
    setUnlockFlag: (state, action) => {
      state.unlockFlag = action.payload;
    },
    setRenderFormData: (state, action) => {
      state.renderFormData = action.payload;
    },
  },
});

export const {
  setCnotePeriod,
  updateNoteSerch,
  setNoteProSerch,
  setNoteSerchAllsignopen,
  setPhoneNotePopup,
  setUnlockFlag,
  setRenderFormData,
} = counsellingNoteSlice.actions;
export default counsellingNoteSlice.reducer;
